import React from 'react';

const CommentIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><rect width="24" height="24" fill="#24a0dc" opacity="0"/><path d="M77.871,4.609a70.473,70.473,0,0,1,11.285.056l2.263.193A3.714,3.714,0,0,1,94.775,8l.143.931a28.794,28.794,0,0,1-.134,9.524,3.265,3.265,0,0,1-3.212,2.68H79.064a1.741,1.741,0,0,0-.825.207L72.79,24.267a1.045,1.045,0,0,1-1.54-.92V11.478A6.868,6.868,0,0,1,77.6,4.629Zm0,6.893a1.742,1.742,0,1,0,1.742,1.742A1.742,1.742,0,0,0,77.869,11.5Zm5.574,0a1.742,1.742,0,1,0,1.742,1.742A1.742,1.742,0,0,0,83.442,11.5Zm3.832,1.742a1.742,1.742,0,1,1,1.742,1.742A1.742,1.742,0,0,1,87.274,13.244Z" transform="translate(-71.25 -2.41)" fill="#0f4975" fillRule="evenodd"/></svg>
  );
};

export default CommentIcon;
